import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LoadingService } from '@app/core/shared';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { Pagination } from '@app/core/shared/models/pagination';
import { TDSReportService } from '../services/tds-report.services';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'tds-reports',
  templateUrl: './tds-reports.component.html',
  styleUrls: ['./tds-reports.component.scss']
})
export class TDSReportsComponent implements OnInit {
  tdsReportsFilterForm!: FormGroup;
  paginationDetails: Pagination = new Pagination();
  tdsReportsTableData: any = [];
  today = new Date();
  minDate = { year: this.today.getFullYear() - 10, month: this.today.getMonth(), day: this.today.getDate() };
  maxDate = { year: this.today.getFullYear(), month: this.today.getMonth(), day: this.today.getDate() };
  orderStatusesList = [];
  rewardTypesList = [];
  lastUpdatePayload = {
    orderStatusId: '',
    rewardType: '',
    fromDate: '',
    toDate: moment(this.today, "DD-MM-YYYY").format("YYYY-MM-DD"),
    orderNumber: '',
    programNumber: '',
    bankAccountNumber: ''
  }

  constructor(private fb: FormBuilder, public loadingService: LoadingService, public toastr: ToastrService, private tdsReportsServices: TDSReportService) { }

  ngOnInit(): void {
    this.initializeForm();
    this.getTDSAppToken(false, false);
  }

  getTDSAppToken(isReportOnlyAPI: boolean = false, isDownloadReport: boolean = false) {
    this.loadingService.doLoading(this.tdsReportsServices.getTDSAppToken(), this).pipe(untilDestroyed(this)).subscribe(async response => {
      if (isDownloadReport) {
        this.loadingService.doLoading(this.tdsReportsServices.getDownloadReports(response.token, this.lastUpdatePayload), this).pipe(untilDestroyed(this)).subscribe(response => {
          const url = window.URL.createObjectURL(new Blob([response]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `reports.csv`);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }, (err) => {
          console.log(err)
        });
      } else {
        if (!isReportOnlyAPI) {
          await this.getRewardTypes(response.token);
          await this.getOrderStatuses(response.token);
        }
        await this.getReports(response.token);
      }
    });
  }

  async getRewardTypes(token) {
    await this.loadingService.doLoading(this.tdsReportsServices.getRewardTypes(token), this).pipe(untilDestroyed(this)).subscribe(response => {
      this.rewardTypesList = response;
    });
  }
  async getOrderStatuses(token) {
    await this.loadingService.doLoading(this.tdsReportsServices.getOrderStatuses(token), this).pipe(untilDestroyed(this)).subscribe(response => {
      this.orderStatusesList = response;
    });
  }

  async getReports(token) {
    const payload = { ...this.lastUpdatePayload, ...this.paginationDetails };
    await this.loadingService.doLoading(this.tdsReportsServices.getReports(token, payload), this).pipe(untilDestroyed(this)).subscribe(response => {
      this.paginationDetails.totalNumberOfItems = response?.totalCount || 0;
      this.paginationDetails.pageNumber = response.pageNumber || 1;
      this.tdsReportsTableData = response.items;
    });
  }

  downloadCSV() {
    this.getTDSAppToken(false, true);
  }

  initializeForm(): void {
    this.tdsReportsFilterForm = this.fb.group({
      orderStatusId: [''],
      rewardType: [''],
      fromDate: [''],
      toDate: moment(this.today, "DD-MM-YYYY").format("DD-MM-YYYY"),
      orderNumber: [''],
      programNumber: [''],
      bankAccountNumber: [''],
    });
  }
  resetFormValues() {
    this.tdsReportsFilterForm.reset({
      orderStatusId: '',
      rewardType: '',
      fromDate: '',
      toDate: moment(this.today, "DD-MM-YYYY").format("DD-MM-YYYY"),
      orderNumber: '',
      programNumber: '',
      bankAccountNumber: ''
    });
  }

  onChange(pagination: Pagination) {
    this.paginationDetails = pagination;
    this.getTDSAppToken(true, false);
  }

  onSubmit(): void {
    const payload = this.tdsReportsFilterForm.value;
    const fromDt = payload.fromDate ? moment(payload.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD") : '';
    const toDt = payload.toDate ? moment(payload.toDate, "DD-MM-YYYY").format("YYYY-MM-DD") : '';
    if (fromDt && toDt && (new Date(fromDt) > new Date(toDt))) {
      this.toastr.error("From Date should be less than or equal to `To Date`");
      return;
    }
    if (payload?.bankAccountNumber && !/^\d*$/.test(payload?.bankAccountNumber)) {
      this.toastr.error("Bank Account number field should contain only numbers!");
      return;
    }
    payload.fromDate = fromDt;
    payload.toDate = toDt;
    this.lastUpdatePayload = payload;
    this.paginationDetails.pageNumber = 1;
    this.getTDSAppToken(true, false);
  }
}
